import React, { useState } from "react";
import { TextField, Button, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

import { blackColor, darkGreyColor, headingColor, primaryColor } from "theme";
import { path } from "constant/pathLinksConstant";
import useOtpTimer from "hooks/useOtpTimer";

import { useResendOtpMutation, useVerifyOtpMutation } from "../../redux/modules/onboarding";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
`;

const OtpContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 75%;
  margin: 32px 0 24px 0;
`;

const OtpInput = styled(TextField)`
  width: 48px;
  max-height: 48px;
  text-align: center;

  & .MuiInputBase-input {
    font-size: 20px;
    text-align: center;
  }
`;

const AccountVerification = ({
  setCurrentPage,
  setSnackbarData,
  setOpenSnackbar,
  email,
  handleClose,
  cameFrom
}) => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const { formattedTime,  isRunning } = useOtpTimer();

  const navigate = useNavigate();

  const [verifyOtp] = useVerifyOtpMutation(
    {},
    {
      pollingInterval: 3000,
      refetchOnMountOrArgChange: true,
      skip: false
    }
  );
  const [resendOtp] = useResendOtpMutation(
    {},
    {
      pollingInterval: 3000,
      refetchOnMountOrArgChange: true,
      skip: false
    }
  );

  const handleChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value;
    setOtp(newOtp);

    // Move to the next input box if a number is entered
    if (e.target.value.length === 1 && index < otp.length - 1) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handleResendOtp = () => {
    if (isRunning) {
      return;
    }
    // Add functionality to resend OTP here
    // console.log("Resend OTP");
    resendOtp({ email }).unwrap().then(() => {
      setSnackbarData({
        message: "OTP sent successfully",
        severity: "success"
      });
      setOpenSnackbar(true);
    }).catch((error) => {
      setSnackbarData({
        message: error.data.message,
        severity: "error"
      });
      setOpenSnackbar(true);
    });
  };

  const handleVerify = () => {
    const enteredOtp = otp.join("");
    // const payload = { data: { uuid: enteredOtp } };
    const payload = {
      email,
      otp: enteredOtp
    };
    verifyOtp(payload)
      .unwrap()
      .then(() => {
     if (cameFrom === 'signup') {
      setTimeout(() => {
        handleClose();
      }, 500);
       navigate(path.app.login);
     }else {
      setCurrentPage("login");
     }
      })
      .catch((error) => {
        setSnackbarData({
          message: error.data.message,
          severity: "error"
        });
        setOpenSnackbar(true);
      });
   
  };

  

  const isButtonDisabled = otp.some((digit) => digit === "");

  return (
    <Root>
      <Typography
        fontSize="24px"
        textAlign="center"
        fontWeight={700}
        id="parent-modal-title"
        className="modal-title"
      >
        Account Verification
      </Typography>
      <Typography textAlign="center" fontSize="13px" color={darkGreyColor}>
        Enter OTP sent on {email}
      </Typography>
      <OtpContainer>
        {otp.map((digit, index) => (
          <OtpInput
            key={index}
            id={`otp-${index}`}
            value={digit}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            inputProps={{
              maxLength: 1,
              className: "otp-input"
            }}
            variant="outlined"
            sx={{ maxHeight: "48px" }}
          />
        ))}
      </OtpContainer>
      <Typography
        variant="text"
        fontSize=".875rem"
        fontWeight="500"
        sx={{cursor: "pointer" }}
        color={isRunning ? headingColor : primaryColor}
        onClick={handleResendOtp}
      >
        {isRunning ? `Resend OTP in ${formattedTime} sec` : "Resend OTP"}
      </Typography>
      <Button
        disabled={isButtonDisabled}
        onClick={handleVerify}
        sx={{ mt: "1.5rem", width: "100%" }}
        variant="primary"
      >
        Verify and Continue
      </Button>
      <Typography
        sx={{ mt: "1.5rem" }}
        textAlign="center"
        fontSize="13px"
        color={blackColor}
      >
        Want to change signup details?{" "}
        <span
          onClick={() => {
            if (cameFrom === 'signup') {
              setCurrentPage("otp");
              handleClose();
            }
            setCurrentPage("signup");
          }
          }
          style={{
            color: primaryColor,
            fontSize: ".875rem",
            cursor: "pointer"
          }}
        >
          {" "}
          Back to Sign Up
        </span>
      </Typography>
    </Root>
  );
};

export default AccountVerification;
